import { render, staticRenderFns } from "./Lookup.vue?vue&type=template&id=86496e18&"
import script from "./Lookup.vue?vue&type=script&lang=js&"
export * from "./Lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports